import type { ApolloError } from '@apollo/client';

import { isGraphQLAuthError } from 'src/modules/error-handling/error-handling';
import type { VisibilityLevel } from 'src/types/graphql';

import { Actions, type ProfileVisibilityAction } from './actions';

export const updateProfileVisibility = (
  level: VisibilityLevel,
): ProfileVisibilityAction => ({
  type: Actions.PROFILE_VISIBILITY_UPDATE_START,
  payload: { level },
  meta: {
    metrics: {
      profileVisibilityLevel: level,
    },
  },
});

export const updateProfileVisibilitySuccess = (): ProfileVisibilityAction => ({
  type: Actions.PROFILE_VISIBILITY_UPDATE_SUCCESS,
});

export const updateProfileVisibilityFailure = (
  error: ApolloError,
): ProfileVisibilityAction => ({
  type: Actions.PROFILE_VISIBILITY_UPDATE_FAILURE,
  payload: error,
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});

export const profileVisibilityDropdownOpened = (): ProfileVisibilityAction => ({
  type: Actions.PROFILE_VISIBILITY_OPENED,
});
